import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { colors } from '../../styles';

export interface Props {
  className?: string;
  children?: any;
}

class PrimaryActionBar extends React.Component<Props, any> {
  public render() {
    const { children, className } = this.props;
    return <div className={`${className} primary-action-bar`}>{children}</div>;
  }
}

export default styled(PrimaryActionBar)`
  background: ${colors.black};
  width: 4rem;
  height: 100vh;
  min-height: 100vh;
  display: flex;
  flex-flow: column;
  z-index: 3;
`;
